import { render } from "./ServiceFeePaySure.vue?vue&type=template&id=5f89868e&scoped=true&ts=true"
import script from "./ServiceFeePaySure.vue?vue&type=script&lang=ts"
export * from "./ServiceFeePaySure.vue?vue&type=script&lang=ts"

import "./ServiceFeePaySure.vue?vue&type=style&index=0&id=5f89868e&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f89868e"]])

export default __exports__